import { Check, Download } from "react-feather";
import styles from "../MoveOutChecklist.module.css";
import { Badge } from "./CommonComponents";

const SubmittedTab = ({ leaseData, moveoutData }) => {
    const isRefund = moveoutData?.final_amount > 0;

    return <div className={`${styles.tp} ${styles.tpActive}`}>
        <div className={styles.sentWrap}>
            <div className={styles.sentIcon}>
                <Check width={34} height={34} />
            </div>
            <div className={styles.sentTitle}>Final statement sent!</div>
            <div className={styles.sentSub}>The move-out condition report has been submitted and the final statement sent to{" "}<strong>{leaseData?.tenant_names}</strong>.</div>
            <div className={styles.sentSummary}>
                <div className={styles.sentRow}>
                    <span style={{ color: "#6B7280" }}>Action</span>
                    <Badge type={isRefund ? "success" : "danger"}>{isRefund ? "Refund issued" : "Balance due"}</Badge>
                </div>
                <div className={styles.sentRow}>
                    <span style={{ color: "#6B7280" }}>Amount</span>
                    <strong style={{ color: isRefund ? "#15803D" : "#991B1B" }}>
                        {isRefund ? "" : "-"}{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format((moveoutData?.final_amount))}
                    </strong>
                </div>
                <div className={styles.sentRow}>
                    <span style={{ color: "#6B7280" }}>Ledger updated</span>
                    <Badge type="success">Posted</Badge>
                </div>
            </div>
            <button className={`${styles.DownloadMoveoutReportBU}`} onClick={() => window.open(moveoutData?.report_file_url, '_blank')}>
                <Download /> Move-Out Condition Report
            </button>
        </div>
    </div>
}

export default SubmittedTab;